import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './store'
import { AuthProvider } from './contexts/AuthContextRedux'
import { ToastProvider } from './contexts/ToastContext'
import { ErrorLogger } from './components/ErrorLogger'
import LoadingSpinner from './components/LoadingSpinner'
import Login from './components/Login'
import ChatLayoutRedux from './components/ChatLayoutRedux'
import HistoryRedux from './components/HistoryRedux'
import MenuPage from './components/MenuPage'
import GeneratorLayout from './components/generator/GeneratorLayout'
import JourneyViewer from './components/generator/JourneyViewer'
import OSACockpit from './components/generator/OSACockpit'
import NotFound from './components/NotFound'
import ProtectedRoute from './components/ProtectedRoute'
import VersionInfo from './components/VersionInfo'

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={<LoadingSpinner text="Loading your data..." />} persistor={persistor}>
        <Router>
          <AuthProvider>
            <ToastProvider>
              <ErrorLogger>
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route
                    path="/menu"
                    element={
                      <ProtectedRoute>
                        <MenuPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/chat/:sessionId?"
                    element={
                      <ProtectedRoute>
                        <ChatLayoutRedux />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/generator"
                    element={
                      <ProtectedRoute>
                        <GeneratorLayout />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/generator/journey/:journeyId"
                    element={
                      <ProtectedRoute>
                        <JourneyViewer />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/osa"
                    element={
                      <ProtectedRoute>
                        <OSACockpit />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/history"
                    element={
                      <ProtectedRoute>
                        <HistoryRedux />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="/" element={<Navigate to="/menu" replace />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </ErrorLogger>
              <VersionInfo />
            </ToastProvider>
          </AuthProvider>
        </Router>
      </PersistGate>
    </Provider>
  )
}

export default App
